module.exports = __webpack_public_path__ + "fonts/Roboto-VariableFont_wdth,wght.3aa911d4.ttf";